const DEFAULT_DELIVERABLES = [
  "Weekly, iterative project milestones",
  "Expert review and final pitch",
  "A portfolio-ready product case study",
];

const BAR_HEIGHTS = [35, 55, 72, 88, 100];

const MockPreview = ({ eyebrow, title }) => (
  <div className="rounded-[26px] bg-primary text-white p-7 flex flex-col min-h-[300px] md:min-h-[340px]">
    <div className="flex justify-between text-[16px]">
      <span className="font-bold tracking-wide">UTIVA</span>
      <small className="opacity-70">CASE STUDY 001</small>
    </div>

    <div className="my-auto py-8">
      {eyebrow && (
        <small className="tracking-[0.1em] text-[18px] opacity-70 block mb-2 uppercase">
          {eyebrow}
        </small>
      )}
      <h3 className="text-2xl md:text-[28px] leading-tight max-w-[330px] font-semibold text-white">
        {title}
      </h3>
    </div>

    <div className="flex items-end gap-2 h-[70px]">
      {BAR_HEIGHTS.map((h, i) => (
        <i
          key={i}
          className="flex-1 bg-secondary rounded-t"
          style={{ height: `${h}%` }}
        />
      ))}
    </div>
  </div>
);

const CoursePortfolioSection = ({ selectedCourseData }) => {
  const portfolio = selectedCourseData?.portofolio;
  const deliverables = portfolio?.deliverables?.length
    ? portfolio.deliverables
    : DEFAULT_DELIVERABLES;

  return (
    <section id="portfolio" className="bg-white">
      <div className="border border-[#DFE6F7] rounded-[26px] bg-white shadow-course-card mb-8 p-6 md:p-9">
        <p className="text-primary tracking-[0.19em] uppercase text-[14px] font-extrabold flex items-center gap-2 mb-4">
          <span className="inline-block w-6 h-[3px] bg-secondary rounded-full" />
          Learn By Building
        </p>
        <h2 className="text-primary font-bold text-3xl md:text-5xl tracking-tight mb-2">
          {portfolio?.title ||
            "Build and Showcase Your Product Portfolio Project"}
        </h2>
        <p className="text-primary text-base font-bold mb-7">
          {portfolio?.subtitle || "Don’t just say you can. Show it."}
        </p>

        <div className="flex flex-col lg:flex-row gap-8">
          <div className="lg:flex-1">
            <MockPreview
              eyebrow={selectedCourseData?.tag}
              title={
                selectedCourseData?.courseOverview?.title
                  ?.split(";")[0]
                  ?.slice(0, 70) || "Make it real."
              }
            />
          </div>

          <div className="self-center lg:flex-1">
            <p className="text-[#565656] text-sm md:text-base leading-relaxed">
              {portfolio?.description}
            </p>

            <ul className="grid gap-3 mt-6">
              {deliverables.map((item) => (
                <li
                  key={item}
                  className="text-[13px] md:text-sm text-[#1E2027] flex items-start gap-2"
                >
                  <span className="text-primary font-extrabold">✓</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoursePortfolioSection;
